/**
 * Wraps a dynamic import with retry logic to handle stale chunk errors
 * after deployments. On failure, retries once with a cache-busting reload.
 */
export function lazyRetry<T extends { default: React.ComponentType<any> }>(
  importFn: () => Promise<T>
): Promise<T> {
  return importFn().catch((error) => {
    // Only retry for chunk load failures
    if (
      error?.message?.includes("Failed to fetch dynamically imported module") ||
      error?.message?.includes("Loading chunk") ||
      error?.name === "ChunkLoadError"
    ) {
      // Check if we already retried to avoid infinite reload loops
      const key = "chunk_retry";
      const lastRetry = sessionStorage.getItem(key);
      const now = Date.now();

      if (!lastRetry || now - Number(lastRetry) > 10000) {
        sessionStorage.setItem(key, String(now));
        window.location.reload();
      }
    }
    throw error;
  });
}
